import * as d3 from 'd3';

export function drawColonialGrillsOctagon(
  svg, x, y, width, height, frameWidth,
  horLines, verLines, lineColor, borderColor, borderWidth,
  grillThickness, innerPoints
) {
  if (!innerPoints || innerPoints.length !== 8) {
    console.error("drawColonialGrillsOctagon: innerPoints missing or invalid (expected 8 points)");
    return;
  }

  // Inner polygon points from shapeOctagon
  // For octagon: 8 points defining the inner octagon
  // Points are clockwise: P1-P8
  // P1 = top-left chamfer, P2 = top-right chamfer
  // P3 = right-top, P4 = right-bottom
  // P5 = bottom-right chamfer, P6 = bottom-left chamfer
  // P7 = left-bottom, P8 = left-top
  const [P1, P2, P3, P4, P5, P6, P7, P8] = innerPoints;

  // Calculate bounding box from innerPoints
  const minX = Math.min(P1[0], P2[0], P3[0], P4[0], P5[0], P6[0], P7[0], P8[0]);
  const maxX = Math.max(P1[0], P2[0], P3[0], P4[0], P5[0], P6[0], P7[0], P8[0]);
  const minY = Math.min(P1[1], P2[1], P3[1], P4[1], P5[1], P6[1], P7[1], P8[1]);
  const maxY = Math.max(P1[1], P2[1], P3[1], P4[1], P5[1], P6[1], P7[1], P8[1]);

  // Create clip path using the actual inner octagon points
  const clipId = `octagonClip_${Math.random().toString(36).substr(2, 9)}`;
  const innerPointsStr = innerPoints.map(p => p.join(',')).join(' ');

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('polygon')
    .attr('points', innerPointsStr);

  const grillGroup = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // ============================================================
  // VERTICAL GRILLS — CLIPPED TO INNER OCTAGON SHAPE
  // ============================================================
  for (let i = 1; i <= verLines; i++) {
    const t = i / (verLines + 1);
    const gx = minX + t * (maxX - minX);

    grillGroup.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', minY)
      .attr('width', grillThickness)
      .attr('height', maxY - minY)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // ============================================================
  // HORIZONTAL GRILLS — CLIPPED TO INNER OCTAGON SHAPE
  // ============================================================
  for (let i = 1; i <= horLines; i++) {
    const t = i / (horLines + 1);
    const gy = minY + t * (maxY - minY);

    grillGroup.append('rect')
      .attr('x', minX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', maxX - minX)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }
}
  